import { Text } from 'components';
import React from 'react';

const PreLaunchLimitedAccess = () => (
  <Text textAlign="center" block={false}>
    You are using a limited version of BrokerBay. Please reach out to your
    managing broker to finish setting up your brokerage.
  </Text>
);

export default PreLaunchLimitedAccess;
